import React from 'react';
import { format } from 'date-fns';

export default function LastUpdated({ value }) {
  return <span>Last updated: {format(value, 'MMM dd, yyyy')}</span>;
}
